module.exports = __webpack_public_path__ + "img/laptop-five.9dff90e0.png";